import { commbankLiabilitiesDefaultContent, CommbankLiabilitiesState } from './commbankLiabilitiesTypes';
import { ApiStatus } from '../../types';

export const initialStateCommbankLiabilities: CommbankLiabilitiesState = {
    content: commbankLiabilitiesDefaultContent,
    getCommbankLiabilitiesAPIStatus: ApiStatus.Idle,
    updateCommbankLiabilitiesAPIStatus: ApiStatus.Idle,
    apiEndpoints: {
        getCommbankLiabilitiesUrl: '/getCommbankLiabilitiesUrl',
        updateCommbankLiabilitiesUrl: '/updateCommbankLiabilitiesUrl',
    },
    commbankLiabilitiesDetails: [],
    updateCommbankLiabilitiesPayload: [],
};
